import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon30: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M10.038 0C11.121 0 12 0.87886 12 1.962V2.505C12 2.78114 11.776 3.005 11.5 3.005C11.224 3.005 11 2.78114 11 2.505V1.962C11 1.43114 10.569 1 10.038 1H1.96198C1.43098 1 1 1.43114 1 1.962V18.038C1 18.5689 1.43098 19 1.96198 19H10.038C10.569 19 11 18.5689 11 18.038V16.501C11 16.2249 11.224 16.001 11.5 16.001C11.776 16.001 12 16.2249 12 16.501V18.038C12 19.1211 11.121 20 10.038 20H1.96198C0.878975 20 0 19.1211 0 18.038V1.962C0 0.87886 0.878975 0 1.96198 0H10.038ZM6.5 17C6.776 17 7 17.2239 7 17.5C7 17.7761 6.776 18 6.5 18H5.5C5.224 18 5 17.7761 5 17.5C5 17.2239 5.224 17 5.5 17H6.5ZM18.04 5C19.123 5 20 5.87786 20 6.96V11.038C20 12.1214 19.121 13 18.037 13H11.708L8.854 15.8536C8.539 16.1685 8 15.9455 8 15.5V13H7.96198C6.87897 13 6 12.1214 6 11.038V6.962C6 5.87856 6.87897 5 7.96198 5H18.04ZM18.04 6H7.96198C7.43097 6 7 6.43074 7 6.962V11.038C7 11.5693 7.43097 12 7.96198 12H8.5C8.777 12 9 12.2239 9 12.5V14.2929L11.147 12.1464C11.241 12.0527 11.368 12 11.5 12H18.037C18.569 12 19 11.569 19 11.038V6.96C19 6.43014 18.57 6 18.04 6ZM10.5 9C10.776 9 11 9.2239 11 9.5C11 9.7761 10.776 10 10.5 10H9.5C9.224 10 9 9.7761 9 9.5C9 9.2239 9.224 9 9.5 9H10.5ZM16.5 9C16.776 9 17 9.2239 17 9.5C17 9.7761 16.776 10 16.5 10H15.5C15.224 10 15 9.7761 15 9.5C15 9.2239 15.224 9 15.5 9H16.5ZM13.5 9C13.776 9 14 9.2239 14 9.5C14 9.7761 13.776 10 13.5 10H12.5C12.224 10 12 9.7761 12 9.5C12 9.2239 12.224 9 12.5 9H13.5ZM7.5 2C7.776 2 8 2.22386 8 2.5C8 2.77614 7.776 3 7.5 3H4.5C4.224 3 4 2.77614 4 2.5C4 2.22386 4.224 2 4.5 2H7.5Z"
        fill="#4775FF"
      />
    </Icon>
  )
}
